import { CRM_SUITE, MARKETING_PLUS_SUITE } from 'self-service-api/constants/BundleTypes';
import DisabledDowngradeButton from '../../../components/buttons/DisabledDowngradeButton';
import RedirectToCustomerPlatformButton from '../../../components/buttons/RedirectToCustomerPlatformButton';
import RedirectToMarketingPlusButton from '../../../components/buttons/RedirectToMarketingPlusButton';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useAppSelector } from '../../../reducers';
import { getBundleTypeInProductInventorySelector, hasHigherProductLevelInProductInventorySelector } from '../../../selectors/ProductInventorySelectors';
import { productForSkuIdSelector } from '../../../selectors/ProductsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MerchCardCTAOverridesWrapper = ({
  skuId,
  trackingSource,
  children,
  size
}) => {
  const isAppReady = useGlobalLoading();
  const {
    productLevel,
    productLine
  } = useAppSelector(state => {
    if (!isAppReady) {
      return {
        productLevel: null,
        productLine: null
      };
    }
    return productForSkuIdSelector(state, {
      skuId
    });
  });
  const hasHigherTieredProduct = useAppSelector(state => {
    if (!productLevel || !productLine) {
      return false;
    }
    return hasHigherProductLevelInProductInventorySelector(state, {
      productLevel,
      productLine
    });
  });
  const ownedBundleType = useAppSelector(state => {
    if (!isAppReady) {
      return null;
    }
    return getBundleTypeInProductInventorySelector(state, {
      skuId
    });
  });
  if (hasHigherTieredProduct) {
    return /*#__PURE__*/_jsx(DisabledDowngradeButton, {
      size: size
    });
  }
  if (ownedBundleType === MARKETING_PLUS_SUITE) {
    return /*#__PURE__*/_jsx(RedirectToMarketingPlusButton, {
      trackingSource: trackingSource,
      size: size
    });
  }
  if (ownedBundleType === CRM_SUITE) {
    return /*#__PURE__*/_jsx(RedirectToCustomerPlatformButton, {
      trackingSource: trackingSource,
      size: size
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default MerchCardCTAOverridesWrapper;